// Tailwind's JIT scanner only generates CSS for class names it finds as literal
// strings in source. A template like `grid-cols-${n}` never resolves to a
// literal, so once `n` isn't already used literally elsewhere in the codebase,
// no `grid-template-columns` rule is generated and the grid silently collapses
// to a single implicit column.
const GRID_COLS_CLASSES = {
  2: "grid-cols-2",
  3: "grid-cols-3",
  4: "grid-cols-4",
  5: "grid-cols-5",
  6: "grid-cols-6",
} as const;

const DEFAULT_COLUMN_COUNT = 4;

export const getCompareTableGridColsClass = (columnCount: number) =>
  GRID_COLS_CLASSES[columnCount as keyof typeof GRID_COLS_CLASSES] ??
  GRID_COLS_CLASSES[DEFAULT_COLUMN_COUNT];
